export * from "./test-uniform-page.template";
export { TestUniformPageTemplate as default } from "./test-uniform-page.template";
